import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-multi-form/jb-multi-form.css.ts
var jb_multi_form_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}jb-multi-form{display:block}jb-multi-form .wrapper{margin-block-end:var(--theme-spacing-xs);position:relative;z-index:2}jb-multi-form jb-form{opacity:1;position:relative;transition:opacity .3s ease-in-out;z-index:1}jb-multi-form jb-form.paused{opacity:.4;pointer-events:none}jb-multi-form .wrapper jb-heading{margin-block-end:var(--theme-spacing-xs)}`;

export {
  jb_multi_form_css_default
};
